import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    placeContent: "center",
    position: "relative",
    cursor: "pointer",
    padding: `${theme.spacing.space12}px ${theme.spacing.space20}px`,
    overflow: "hidden",
    border: `none`,
    background: theme.colors.Primary,
    color: theme.colors.TextDefault,
    borderRadius: theme.radius.button,
    textAlign: "-webkit-center",
    fontSize: 18,
    fontWeight: theme.fontWeight.semiBold,
    fontFamily: "Poppins",
    boxSizing: "border-box",
    width: "fit-content",
    "& > span": {
      "&.ripple": {
        position: "absolute",
        borderRadius: "50%",
        transform: "scale(0)",
        animation: "$ripple 600ms linear",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
      },
    },
    "&.only-icon": {
      borderRadius: "50%",
      padding: `${theme.spacing.space8}px !important`,
      cursor: "auto",
    },
    "&.fullWidth": {
      width: "100%",
    },
    "&.smaller": {
      padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
      fontSize: 12,
      fontWeight: theme.fontWeight.medium,
    },
    "&.small": {
      padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
      fontSize: 14,
      fontWeight: theme.fontWeight.medium,
    },
    "&.outlined": {
      background: "transparent",
      border: `1px solid ${theme.colors.Border3}`,
      color: theme.colors.TextDefault,
    },
    "&.borderless": {
      background: "transparent",
      color: theme.colors.TextDefault,
    },
    "&.disabled": {
      background: theme.colors.Background5,
      color: theme.colors.TextDisable,
      border: "none",
      pointerEvents: "none",
    },
  },
  overlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
  },
  iconSize: {
    zIndex: 1,
    paddingInlineStart: theme.spacing.space8,
    fontSize: 24,
    "&.small": {
      paddingInlineStart: theme.spacing.space4,
      lineHeight: "24px",
    },
    "&.only-icon": {
      paddingInlineStart: 0,
      width: theme.spacing.space40,
      "&.large": {
        fontSize: theme.spacing.space32,
        lineHeight: "32px",
      },
    },
  },
  "@keyframes ripple": {
    to: {
      transform: "scale(3)",
      opacity: 0,
    },
  },
}));
